import { ChangeBusinessDetails } from './ChangeBusinessDetails';

export class ChangeBusinessStatement extends ChangeBusinessDetails {
  type: string = 'ChangeBusinessStatement';
}
